export enum WORK_ORDER_STATUS {
  Opened = "opened",
  Released = "released",
}

export type ItensWorkOrder = {
  _id: string;
  name: string;
  quantity: number;
  type: string;
  sellPrice: number;
  productOrWorkId: string;
};

export enum WORK_ORDER_TYPE {
  INVENTORY_ADJUSTMENT = "adjustment",
  MAINTENANCE = "maintenance",
  PREPARATION = "preparation",
  REPREPARATION = "repreparation",
}

export type WorkOrderType = {
  _id: string;
  workOrderCode: string;
  licensePlate: string;
  itens: ItensWorkOrder[];
  createdAt: Date;
  updatedAt: Date;
  status: WORK_ORDER_STATUS;
};
export type IWorkOrder = {
  _id: string;
  workOrderCode: string;
  mechanic: string;
  licensePlate: string;
  itens: ItensWorkOrder[];
  createdAt: Date;
  updatedAt: Date;
  status: WORK_ORDER_STATUS;
  typeOfPiece?: string;
  companyId?: string;
  type: WORK_ORDER_TYPE;
  observation?: string;
  kitPPF?: boolean;
  tracker?: boolean;
  cellphoneSupport?: boolean;
  engineProtection?: boolean;
  cellphoneCharger?: boolean;
};
export type IWorkOrderWithPreparation = IWorkOrder & {
  vehiclePreparing: unknown;
  vehicleId: string;
  model: string;
};
export interface IPartnerPreparationReport {
  dashboard: {
    releasedCount: number;
    openedCount: number;
    billedCount: number;
  };
  workOrders: IWorkOrderWithPreparation[];
}

export const emptyWorkOrder = () =>
  ({
    _id: "",
    workOrderCode: "",
    mechanic: "",
    licensePlate: "",
    itens: [],
    createdAt: new Date(),
    updatedAt: new Date(),
    status: WORK_ORDER_STATUS.Opened,
    observation: "",
    type: WORK_ORDER_TYPE.MAINTENANCE,
  } as IWorkOrder);
